import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  stepRoot: {
    width: '100%',
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      flex: 1,
      minHeight: 0,
    },
  },
  stepMain: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      flex: 1,
      minHeight: 0,
    },
  },
  stepFormFill: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      flex: 1,
      minHeight: 0,
    },
  },
}));
